import { StoreState } from '@/redux/types';
import { getFeatures } from './getFeatures';

export const getAreSpecialFontsAvailable = (state: StoreState) =>
  getFeatures(state).showAddSpecialText;
